export const VIEW_MODE_SEARCH_PARAM = 'view';
